export default "__VITE_ASSET__f983f66e__"